import React from 'react'

import ExpandablePanel from '../controls/ExpandablePanel'
import FormControl from '@material-ui/core/FormControl'
import FormHelperText from '@material-ui/core/FormHelperText'
import TextField from '@material-ui/core/TextField'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Checkbox from '@material-ui/core/Checkbox'
import { controlHasError } from '../../lib/errorHandler'

class AdresPrzedsiebiorcy extends React.Component {
  render() {
    const { data, onChangeData, validateErrors } = this.props
    return (
      <ExpandablePanel title="DANE ADRESOWE">
        <form autoComplete="off" className="adres">
          <div className="firstRow">
            <FormControl component="fieldset">
              <TextField
                name="ulica"
                label="Ulica"
                title={data.ulica}
                value={data.ulica}
                onChange={e => onChangeData(e.target.name, e.target.value)}
              />
            </FormControl>

            <FormControl
              component="fieldset"
              error={controlHasError(validateErrors, 'nrDomu')}
            >
              <TextField
                error={controlHasError(validateErrors, 'nrDomu')}
                name="nrDomu"
                label="Nr domu"
                aria-describedby="dom-error-text"
                title={data.nrDomu}
                value={data.nrDomu}
                onChange={e => onChangeData(e.target.name, e.target.value)}
              />
              {controlHasError(validateErrors, 'nrDomu') && (
                <FormHelperText id="dom-error-text">
                  Pole wymagane
                </FormHelperText>
              )}
            </FormControl>

            <FormControl component="fieldset">
              <TextField
                name="nrLokalu"
                label="Nr lokalu"
                title={data.nrLokalu}
                value={data.nrLokalu}
                onChange={e => onChangeData(e.target.name, e.target.value)}
              />
            </FormControl>
          </div>
          <div className="secondRow">
            <FormControl
              component="fieldset"
              error={controlHasError(validateErrors, 'miejscowosc')}
            >
              <TextField
                error={controlHasError(validateErrors, 'miejscowosc')}
                name="miejscowosc"
                label="Miejscowość"
                aria-describedby="miejscowosc-error-text"
                title={data.miejscowosc}
                value={data.miejscowosc}
                onChange={e => onChangeData(e.target.name, e.target.value)}
              />
              {controlHasError(validateErrors, 'miejscowosc') && (
                <FormHelperText id="miejscowosc-error-text">
                  Pole wymagane
                </FormHelperText>
              )}
            </FormControl>
            <FormControl component="fieldset">
              <TextField
                name="kodPocztowy"
                label="Kod pocztowy"
                title={data.kodPocztowy}
                value={data.kodPocztowy}
                onChange={e => onChangeData(e.target.name, e.target.value)}
              />
            </FormControl>

            <FormControl component="fieldset">
              <TextField
                name="poczta"
                label="Poczta"
                title={data.poczta}
                value={data.poczta}
                onChange={e => onChangeData(e.target.name, e.target.value)}
              />
            </FormControl>
          </div>
          <div className="thirdRow">
            <FormControl
              component="fieldset"
              error={controlHasError(validateErrors, 'emailDoFaktury')}
            >
              <TextField
                error={controlHasError(validateErrors, 'emailDoFaktury')}
                name="emailDoFaktury"
                label="adres email do faktury"
                aria-describedby="emailDoFaktury-error-text"
                title={data.emailDoFaktury}
                value={data.emailDoFaktury}
                onChange={e => onChangeData(e.target.name, e.target.value)}
              />
              {controlHasError(validateErrors, 'emailDoFaktury') && (
                <FormHelperText id="emailDoFaktury-error-text">
                  Pole wymagane (wymagany poprawny adres email)
                </FormHelperText>
              )}
            </FormControl>
            <FormControlLabel
              className={
                controlHasError(validateErrors, 'zgodaNaEmailDoFaktury')
                  ? 'errorCheckboxLabel high-caption'
                  : 'high-caption'
              }
              control={
                <Checkbox
                  name="zgodaNaEmailDoFaktury"
                  color="primary"
                  defaultChecked={data.zgodaNaEmailDoFaktury}
                  onChange={e =>
                    onChangeData('zgodaNaEmailDoFaktury', e.target.checked)
                  }
                />
              }
              label="Wyrażam zgodę na przesłanie faktury w formie elektronicznej na wskazany adres email"
            />
          </div>
        </form>
      </ExpandablePanel>
    )
  }
}

export default AdresPrzedsiebiorcy
